module.exports = __webpack_public_path__ + "static/media/24UHCHR13.dd53f094.jpg";